export default "__VITE_ASSET__Dmouff7T__"